import { render, staticRenderFns } from "./ManufacturerSettings.vue?vue&type=template&id=be346b52"
import script from "./ManufacturerSettings.vue?vue&type=script&lang=js"
export * from "./ManufacturerSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports